module.exports = __webpack_public_path__ + "static/02-572594edf4384e7cfeb5ff98b7994086.jpg";